import { ButtonTabs } from "../components/ui";
import { useEffect, useMemo } from "react";
import { Stack } from "@mui/system";
import { AccountPlanReports } from "../components/company";
import { PlaybookReports } from "../components/company/reports";
import { useStateWithSearchParams } from "../hooks";
import { useNavigate } from "react-router-dom";
import { AppRoutes, PlaybookPlanNames } from "../types/enums";

export const AccountReportsPage = ({
  isHidePlaybook,
  isHideAccountPlan,
  hasAccountPlan,
}: {
  isHidePlaybook: boolean;
  isHideAccountPlan: boolean;
  hasAccountPlan: boolean;
}) => {
  const navigate = useNavigate();
  const { searchDict, setSearchValue } = useStateWithSearchParams<{
    subTab?: PlaybookPlanNames;
  }>({
    subTab: !isHideAccountPlan
      ? PlaybookPlanNames.account_plan
      : PlaybookPlanNames.playbook,
  });

  const mapper = useMemo(
    () => ({
      [PlaybookPlanNames.account_plan]: (
        <AccountPlanReports hasAccountPlan={hasAccountPlan} />
      ),
      [PlaybookPlanNames.playbook]: <PlaybookReports />,
    }),
    [hasAccountPlan],
  );

  useEffect(() => {
    if (
      searchDict.subTab &&
      ![PlaybookPlanNames.playbook, PlaybookPlanNames.account_plan].includes(
        searchDict.subTab,
      )
    ) {
      navigate(AppRoutes.CAMPAIGNS, { replace: true });
    }
  }, [searchDict.subTab]);

  const tabsList = [
    { label: PlaybookPlanNames.account_plan, isHide: isHideAccountPlan },
    { label: PlaybookPlanNames.playbook, isHide: isHidePlaybook },
  ];

  return (
    <Stack flexDirection={"row"} gap={"32px"} flexGrow={1}>
      <Stack minWidth={"200px"} maxWidth={"200px"}>
        <ButtonTabs
          fullWidth={true}
          isVertical={true}
          currentTab={searchDict.subTab || ""}
          onChange={(tab) => setSearchValue("subTab", tab)}
          tabList={tabsList.map(({ label, isHide }) => (isHide ? "" : label))}
        />
      </Stack>
      {searchDict.subTab && mapper[searchDict.subTab as keyof typeof mapper]}
    </Stack>
  );
};
